import { render, staticRenderFns } from "./ToolTips.vue?vue&type=template&id=12ab466a&scoped=true"
import script from "./ToolTips.vue?vue&type=script&lang=ts"
export * from "./ToolTips.vue?vue&type=script&lang=ts"
import style0 from "./ToolTips.vue?vue&type=style&index=0&id=12ab466a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ab466a",
  null
  
)

export default component.exports